import * as Web3 from 'web3';

import { PolicyRegistryContract } from '../wrappers';

import { AsekuroConfig } from '../types';

export interface AsekuroContracts {
    policyRegistry: PolicyRegistryContract;
}

export class ContractsAPI {
    private web3: Web3;
    private asekuroConfig: AsekuroConfig;

    public constructor(web3: Web3, asekuroConfig: AsekuroConfig) {
        this.web3 = web3;
        this.asekuroConfig = asekuroConfig;
    }

    public async loadAsekuroContractsAsync(txOptions: object = {}): Promise<AsekuroContracts> {
        const policyRegistry = await this.loadPolicyRegistryAsync(txOptions);

        return {
            policyRegistry
        }
    }

    public async loadPolicyRegistryAsync(txOptions: object = {}): Promise<PolicyRegistryContract> {
        let policyRegistry: PolicyRegistryContract;

        if (this.asekuroConfig.policyRegistryAddress) {
            policyRegistry = await PolicyRegistryContract.at(
                this.asekuroConfig.policyRegistryAddress,
                this.web3,
                txOptions
            );
        } else {
            policyRegistry = await PolicyRegistryContract.deployed(this.web3, txOptions);
        }

        return policyRegistry;
    }
}
